/*************************************************************************
 *
 * COMPRO CONFIDENTIAL
 * __________________
 *
 *  [2015] - [2020] Compro Technologies Private Limited
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Compro Technologies Private Limited. The
 * intellectual and technical concepts contained herein are
 * proprietary to Compro Technologies Private Limited and may
 * be covered by U.S. and Foreign Patents, patents in process,
 * and are protected by trade secret or copyright law.
 *
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Compro Technologies Pvt. Ltd..
 ***************************************************************************/

/***********************************************************
 * comproDLS SDK AUTHEXTN Adaptor
 * Functions for calling AUTHEXTN API.
 ************************************************************/

var q = require('q');
var request = require('superagent');
var helpers = require('../../helpers');
var Agent = require('agentkeepalive');

var DLSError = helpers.errors.DLSError;

/*********************************
 * Setting Up Module Entry Point
 **********************************/
module.exports = authextn;

var keepaliveAgent = new Agent({
  timeout: 60000,
  freeSocketTimeout: 30000
});

//AuthExtn Adaptor Contsructor
function authextn() {
  return {
    // Gradeformat related APIs
    createGradeformat: createGradeformat.bind(this),
    updateGradeformat: updateGradeformat.bind(this),
    deleteGradeformat: deleteGradeformat.bind(this),
    getAllGradeformats: getAllGradeformats.bind(this),
    getParticularGradeformat: getParticularGradeformat.bind(this),
    associateGradeformatToClass: associateGradeformatToClass.bind(this),
    unassociateGradeformatFromClass: unassociateGradeformatFromClass.bind(this),
    updateClassGradeformatAssociation: updateClassGradeformatAssociation.bind(this),
    getParticularGradeformatOfAClass: getParticularGradeformatOfAClass.bind(this),
    getAllGradeformatsOfAClass: getAllGradeformatsOfAClass.bind(this),
    getClassesOfAGradeformat: getClassesOfAGradeformat.bind(this),

    // Assigned-path related APIs
    createUserAssignedPathEnrollments: createUserAssignedPathEnrollments.bind(this),
    deleteUserAssignedPathEnrollments: deleteUserAssignedPathEnrollments.bind(this),

    // Class related APIs
    getParticularClassV2: getParticularClassV2.bind(this),

    // Org Entitlement related APIs
    createOrgProductEntitlement: createOrgProductEntitlement.bind(this),
    updateOrgProductEntitlement: updateOrgProductEntitlement.bind(this),
    getParticularOrgProductEntitlement: getParticularOrgProductEntitlement.bind(this),
    getAllOrgProductEntitlements: getAllOrgProductEntitlements.bind(this)
  };
}

/*********************************
 * Public Function definitions
 **********************************/

/*
  options = {
    body : {
      gradeformat_id: "string", //mandatory
      grades:[ {                //mandatory
        id: "string",
        title: "string",
        min_threshold: "string",
        max_threshold: "string",
        target: boolean
      }, ...]
      data: {}
    }
  }
*/
function createGradeformat(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();

  //Validations
  var error = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(error) {
      dfd.reject(error);
  } else {
    if(options && options.body) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTHEXTN + self.config.AUTHEXTN_API_URLS.gradeFormat;
      url = helpers.api.constructAPIUrl(url, {
        orgid: self.orgId
      });

      var requestAPI = request.post(url)
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .send(options.body);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI
        .agent(keepaliveAgent)
        .end(function(error, response) {
          if(error) {
            var err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
            dfd.reject(err);
          }
          else { dfd.resolve(response.body); }
      });
    } else {
      var err = {};
      err.message = err.description = 'Mandatory param - body' +
                                      ' not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

/*
  options = {
    gradeformat_id: "string",    // Mandatory
    body : {
      grades: [ {
        id: "string",
        title: "string",
        min_threshold: "string",
        max_threshold: "string",
        target: boolean
      }, ...]
      data: {...}
    }
  }
*/
function updateGradeformat(options) {
  // Initializing promise
  var deferred = q.defer();
  var self = this;
  var error = {};

  //Validations
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) {
    deferred.reject(err);
  } else {
    if (options && options.gradeformat_id && options.body) {
      if (Object.keys(options.body).length !== 0) {
        // Passed all validations, Contruct API url
        var url = self.config.DEFAULT_HOSTS.AUTHEXTN + self.config.AUTHEXTN_API_URLS.particularGradeFormat;

        url = helpers.api.constructAPIUrl(url, {
          orgid: self.orgId, gradeformat_id: options.gradeformat_id
        });

        var params = options.body;
        // Setup request with URL and Params
        var requestAPI = request.put(url)
          .set('Content-Type', 'application/json')
          .set('Accept', 'application/json')
          .send(params);

        if (self.traceid) {
          requestAPI.set('X-Amzn-Trace-Id', self.traceid);
        }

        //Setup token in Authorization header
        requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

        requestAPI
          .agent(keepaliveAgent)
          .end(function(error, response) {
            if (error) {
              error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
              deferred.reject(error);
            } else {
              deferred.resolve(response.body);
            }
          });
      } else {
        error.message = error.description = 'Body of the request cannot be empty.';
        error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
        deferred.reject(error);
      }
    } else {
      error.message = error.description = 'Mandatory params: gradeformat_id or body' +
        ' not found in the request options.';
      error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
      deferred.reject(error);
    }
  }

  return deferred.promise;
}

/*
  options = {
    gradeformat_id: "string" //mandatory
  }
*/
function deleteGradeformat(options) {
  var self = this;
  var dfd = q.defer();

  //Validations
  var error = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(error) {
      dfd.reject(error);
  } else {
    if(options && options.gradeformat_id) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTHEXTN + self.config.AUTHEXTN_API_URLS.particularGradeFormat;
      url = helpers.api.constructAPIUrl(url, {
        orgid: self.orgId, gradeformat_id: options.gradeformat_id
      });

      // Setup request with URL and Params
      var requestAPI = request.delete(url);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI
        .agent(keepaliveAgent)
        .end(function (error, response) {
          if(error) {
            var err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
            dfd.reject(err);
          }
          else { dfd.resolve(response.body); }
      });
    }
    else {
      var err = {};
      err.message = err.description = 'Mandatory params - gradeformat_id' +
                                      ' not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }

  return dfd.promise;
}

/*
  options = {
    gradeformat_id: "string" //mandatory
  }
*/
function getParticularGradeformat (options) {
  // Initializing promise
  var deferred = q.defer();
  var self = this;

  //Validations
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) {
    deferred.reject(err);
  } else {
    if (options && options.gradeformat_id) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTHEXTN + self.config.AUTHEXTN_API_URLS.gradeFormat ;

      url = helpers.api.constructAPIUrl(url, {
        orgid: self.orgId
      });

      // Setup request with URL and Params
      var params = {gradeformat_id: options.gradeformat_id};
      var requestAPI = request.get(url).query(params);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI
        .agent(keepaliveAgent)
        .end(function(error, response) {
          if (error) {
            error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
            deferred.reject(error);
          } else {
            deferred.resolve(response.body.entities[0]);
          }
      });
    } else {
      var error = {};
      error.message = error.description = 'Mandatory params: gradeformat_id' +
        ' not found in request options.';
      error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
      deferred.reject(error);
    }
  }
  return deferred.promise;
}

/*
  options = {
    cursor: "string"
  }
*/
function getAllGradeformats (options) {
  // Initializing promise
  var deferred = q.defer();
  var self = this;

  //Validations
  var err = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(err) {
    deferred.reject(err);
  } else {
    // Passed all validations, Contruct API url
    var url = self.config.DEFAULT_HOSTS.AUTHEXTN + self.config.AUTHEXTN_API_URLS.gradeFormat;

    url = helpers.api.constructAPIUrl(url, {
      orgid: self.orgId
    });

    // Setup request with URL and Params
    var params = {};
    if(options && options.cursor){ params.cursor = options.cursor; }

    var requestAPI = request.get(url).query(params);

    if (self.traceid) {
      requestAPI.set('X-Amzn-Trace-Id', self.traceid);
    }

    //Setup token in Authorization header
    requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

    requestAPI
      .agent(keepaliveAgent)
      .end(function(error, response) {
        if (error) {
          error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          deferred.reject(error);
        } else {
          deferred.resolve(response.body);
        }
      });
  }
  return deferred.promise;
}

/**
 * @param {
 *   *classid: 'string',
 *   *gradeformat_id: 'string',
 *   *body: {
 *     *grades: [{
 *       id: 'string',
 *       title: 'string',
 *       min_threshold: 'string',
 *       max_threshold: 'string',
 *       target: <boolean>
 *     }],
 *     data: {}
 *   }
 * } options
 */
function associateGradeformatToClass(options) {
  var self = this;
  // Initializing promise
  var deferred = q.defer();
  // Validations
  var error = helpers.validations.isAuthenticated(self.orgId, self.token);
  if (error) {
    deferred.reject(error);
  } else {
    if (options && options.classid && options.gradeformat_id && options.body) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTHEXTN +
        self.config.AUTHEXTN_API_URLS.classGradeformatAssociation;

      url = helpers.api.constructAPIUrl(url, {
        orgid: self.orgId,
        classid: options.classid,
        gradeformat_id: options.gradeformat_id
      });

      // Setup request with URL and Params
      var requestAPI = request
        .post(url)
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json')
        .send(options.body);

      // Setup traceid in request header
      if (self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      // Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI.agent(keepaliveAgent).end(function (error, response) {
        if (error) {
          error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          deferred.reject(error);
        } else {
          deferred.resolve(response.body);
        }
      });
    } else {
      error = {};
      error.message = error.description = 'Mandatory params - classid or gradeformat_id or body' +
        ' not found in request options.';
      error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
      deferred.reject(error);
    }
  }

  return deferred.promise;
}

/**
 * @param {
 *   *classid: 'string',
 *   *gradeformat_id: 'string'
 * } options
 */
function unassociateGradeformatFromClass(options) {
  var self = this;
  // Initializing promise
  var deferred = q.defer();
  // Validations
  var error = helpers.validations.isAuthenticated(self.orgId, self.token);
  if (error) {
    deferred.reject(error);
  } else {
    if (options && options.classid && options.gradeformat_id) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTHEXTN +
        self.config.AUTHEXTN_API_URLS.classGradeformatAssociation;

      url = helpers.api.constructAPIUrl(url, {
        orgid: self.orgId,
        classid: options.classid,
        gradeformat_id: options.gradeformat_id
      });

      // Setup request with URL
      var requestAPI = request.delete(url);

      // Setup traceid in request header
      if (self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      // Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI.agent(keepaliveAgent).end(function (error, response) {
        if (error) {
          error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          deferred.reject(error);
        } else {
          deferred.resolve(response.body);
        }
      });
    } else {
      error = {};
      error.message = error.description = 'Mandatory params - classid or gradeformat_id' +
        ' not found in request options.';
      error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
      deferred.reject(error);
    }
  }

  return deferred.promise;
}

/**
 * @param {
 *   *classid: 'string',
 *   *gradeformat_id: 'string',
 *   *body: {
 *     grades: [{
 *       id: 'string',
 *       title: 'string',
 *       min_threshold: 'string',
 *       max_threshold: 'string',
 *       target: <boolean>
 *     }],
 *     data: {}
 *   }
 * } options
 */
function updateClassGradeformatAssociation(options) {
  var self = this;
  // Initializing promise
  var deferred = q.defer();
  // Validations
  var error = helpers.validations.isAuthenticated(self.orgId, self.token);
  if (error) {
    deferred.reject(error);
  } else {
    if (options && options.classid && options.gradeformat_id && options.body) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTHEXTN +
        self.config.AUTHEXTN_API_URLS.classGradeformatAssociation;

      url = helpers.api.constructAPIUrl(url, {
        orgid: self.orgId,
        classid: options.classid,
        gradeformat_id: options.gradeformat_id
      });

      // Setup request with URL and Params
      var params = options.body;
      var requestAPI = request.put(url)
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json')
        .send(params);

      // Setup traceid in request header
      if (self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      // Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI.agent(keepaliveAgent).end(function (error, response) {
        if (error) {
          error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          deferred.reject(error);
        } else {
          deferred.resolve(response.body);
        }
      });
    } else {
      error = {};
      error.message = error.description = 'Mandatory params: classid or gradeformat_id or body' +
        ' not found in the request options.';
      error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
      deferred.reject(error);
    }
  }

  return deferred.promise;
}

/**
 * @param {
 *   *classid: 'string',
 *   *gradeformat_id: 'string'
 * } options
 */
function getParticularGradeformatOfAClass(options) {
  var self = this;
  // Initializing promise
  var deferred = q.defer();
  // Validations
  var error = helpers.validations.isAuthenticated(self.orgId, self.token);
  if (error) {
    deferred.reject(error);
  } else {
    if (options && options.classid && options.gradeformat_id) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTHEXTN + self.config.AUTHEXTN_API_URLS.classGradeformats;

      url = helpers.api.constructAPIUrl(url, {
        orgid: self.orgId,
        classid: options.classid
      });

      // Setup request with URL and Params
      var params = { gradeformat_id: options.gradeformat_id };
      var requestAPI = request.get(url).query(params);

      // Setup traceid in request header
      if (self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      // Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI.agent(keepaliveAgent).end(function (error, response) {
        if (error) {
          error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          deferred.reject(error);
        } else {
          deferred.resolve(response.body.entities[0]);
        }
      });
    } else {
      error = {};
      error.message = error.description = 'Mandatory params: classid or gradeformat_id' +
        ' not found in request options.';
      error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
      deferred.reject(error);
    }
  }

  return deferred.promise;
}

/**
 * @param {
 *   *classid: 'string',
 *   cursor: 'string'
 * } options
 */
function getAllGradeformatsOfAClass(options) {
  var self = this;
  // Initializing promise
  var deferred = q.defer();
  // Validations
  var error = helpers.validations.isAuthenticated(self.orgId, self.token);
  if (error) {
    deferred.reject(error);
  } else {
    if (options && options.classid) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTHEXTN + self.config.AUTHEXTN_API_URLS.classGradeformats;

      url = helpers.api.constructAPIUrl(url, {
        orgid: self.orgId,
        classid: options.classid
      });

      // Setup request with URL and Query Params
      var params = {};
      if (options.cursor) { params.cursor = options.cursor; }

      var requestAPI = request.get(url).query(params);

      // Setup traceid in request header
      if (self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      // Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI.agent(keepaliveAgent).end(function (error, response) {
        if (error) {
          error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          deferred.reject(error);
        } else {
          deferred.resolve(response.body);
        }
      });
    } else {
      error = {};
      error.message = error.description = 'Mandatory params: classid' +
        ' not found in request options.';
      error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
      deferred.reject(error);
    }
  }

  return deferred.promise;
}

/**
 * @param {
 *   *gradeformat_id: 'string',
 *   cursor: 'string'
 * } options
 */
function getClassesOfAGradeformat(options) {
  var self = this;
  // Initializing promise
  var deferred = q.defer();
  // Validations
  var error = helpers.validations.isAuthenticated(self.orgId, self.token);
  if (error) {
    deferred.reject(error);
  } else {
    if (options && options.gradeformat_id) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTHEXTN +
        self.config.AUTHEXTN_API_URLS.gradeformatClasses;

      url = helpers.api.constructAPIUrl(url, {
        orgid: self.orgId,
        gradeformat_id: options.gradeformat_id
      });

      // Setup request with URL and Query Params
      var params = {};
      if (options.cursor) { params.cursor = options.cursor; }

      var requestAPI = request.get(url).query(params);

      // Setup traceid in request header
      if (self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      // Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI.agent(keepaliveAgent).end(function (error, response) {
        if (error) {
          error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          deferred.reject(error);
        } else {
          deferred.resolve(response.body);
        }
      });
    } else {
      error = {};
      error.message = error.description = 'Mandatory params: gradeformat_id' +
        ' not found in request options.';
      error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
      deferred.reject(error);
    }
  }

  return deferred.promise;
}

/*
  options = {
    assignedpathid: "string",  // Mandatory
    classid: "string",         // Mandatory
    body : {
      "users":[                   // min:1 , max: 50
        {
          extUserId: "string",   // Mandatory
        }
          ....
      ],
      "context": {}          // Optional
    }
  }
*/
function createUserAssignedPathEnrollments(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();

  //Validations
  var error = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(error) {
      dfd.reject(error);
  } else {
    if(options && options.classid && options.assignedpathid && options.body) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTHEXTN +
        self.config.AUTHEXTN_API_URLS.userAssignedPaths;
      url = helpers.api.constructAPIUrl(url, {
        orgid: self.orgId,
        classid: options.classid,
        assignedpathid: options.assignedpathid,
      });

      var requestAPI = request.post(url)
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .send(options.body);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI
        .agent(keepaliveAgent)
        .end(function(error, response) {
          if(error) {
            var err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
            dfd.reject(err);
          }
          else { dfd.resolve(response.body); }
      });
    } else {
      var err = {};
      err.message = err.description = 'Mandatory param: classid, assignedpathid, body' +
        ' not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

/*
  options = {
    assignedpathid: "string",  // Mandatory
    classid: "string",         // Mandatory
    body : [                   // min:1 , max: 50
      {
        extUserId: "string", //Mandatory
      },
      ...
    ]
  }
*/
function deleteUserAssignedPathEnrollments(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();

  //Validations
  var error = helpers.validations.isAuthenticated(self.orgId, self.token);
  if(error) {
      dfd.reject(error);
  } else {
    if(options && options.classid && options.assignedpathid && options.body) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTHEXTN +
        self.config.AUTHEXTN_API_URLS.userAssignedPaths;
      url = helpers.api.constructAPIUrl(url, {
        orgid: self.orgId,
        classid: options.classid,
        assignedpathid: options.assignedpathid,
      });

      var requestAPI = request.delete(url)
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .send(options.body);
      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      //Setup token in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI
        .agent(keepaliveAgent)
        .end(function(error, response) {
          if(error) {
            var err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
            dfd.reject(err);
          }
          else { dfd.resolve(response.body); }
      });
    } else {
      var err = {};
      err.message = err.description = 'Mandatory param: classid, assignedpathid, body' +
        ' not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

/**
 * @param {
 *  classid: <string>,         // mandatory
 *  productDetails: <Boolean>,  // optional
 *  bundleDetails: <Boolean>    // optional
 * } options
 */
function getParticularClassV2(options) {
  var self = this;
  //Initializing promise
  var deferred = q.defer();

  //Validations
  var error = helpers.validations.isAuthenticated(self.orgId, self.token);
  if (error) {
    deferred.reject(error);
  } else {
    if (options && options.classId) {
      // Passed all validations, Contruct the API URL
      var url = self.config.DEFAULT_HOSTS.AUTHEXTN + self.config.AUTHEXTN_API_URLS.particularClass;
      url = helpers.api.constructAPIUrl(url, { orgId: self.orgId, classId: options.classId });

      // Setup request with URL and Query Params
      var params = { productDetails: options.productDetails, bundleDetails: options.bundleDetails };
      var requestAPI = request.get(url).query(params);

      // Setup 'traceid' in request header
      if (self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      // Setup 'token' in Authorization header
      requestAPI = helpers.api.setupAPIToken(requestAPI, self.token);

      requestAPI.agent(keepaliveAgent).end(function (error, response) {
        if (error) {
          error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          deferred.reject(error);
        } else {
          deferred.resolve(response.body);
        }
      });
    } else {
      error = {};
      error.message = error.description = 'Mandatory field \'classId\' not found in request options.';
      error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
      deferred.reject(error);
    }
  }

  return deferred.promise;
}

/**
 * @param {
 *  *productcode: "string",
 *  status: "string"             // ['active', 'revoked'] - default: 'active'
 *  expired: <boolean>,          // default: false
 *  startdate: <epoch>,
 *  enddate: <epoch>,
 *  audit: <boolean>             // [true] - default: true
 *  ext_data: {...},
 * } options
 */
function createOrgProductEntitlement(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();
  if (!self.orgId) {
    var err = {};
    err.message = err.description = 'Mandatory param: orgid not found in options while ' +
      'initializing comprodls-sdk.';
    err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
    dfd.reject(err);
  } else {
    if (options && options.productcode) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTHEXTN +
        self.config.AUTHEXTN_API_URLS.orgProductEntitlement;
      url = helpers.api.constructAPIUrl(url, { orgid: self.orgId });

      var requestAPI = request.post(url)
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json')
        .send(options);

      if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      requestAPI
        .agent(keepaliveAgent)
        .end(function(error, response) {
          if (error) {
            var err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
            dfd.reject(err);
          }
          else { dfd.resolve(response.body); }
      });
    } else {
      var err = {};
      err.message = err.description = 'Mandatory param: productcode not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }
  return dfd.promise;
}

/**
 * @param {
 *  *productcode: "string",
 *  status: "string"             // ['active', 'revoked']
 *  expired: <boolean>,
 *  startdate: <epoch>,
 *  enddate: <epoch>,
 *  audit: <boolean>             // [true] - default: true
 *  ext_data: {...},
 * } options
 */
function updateOrgProductEntitlement(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();

  if (!self.orgId) {
    var err = {};
    err.message = err.description = 'Mandatory param: orgid not found in options while ' +
      'initializing comprodls-sdk.';
    err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
    dfd.reject(err);
  } else {
    if (options && options.productcode) {
      // Passed all validations, Contruct API url
      var url = self.config.DEFAULT_HOSTS.AUTHEXTN +
        self.config.AUTHEXTN_API_URLS.orgProductEntitlement;
      url = helpers.api.constructAPIUrl(url, { orgid: self.orgId });

      var requestAPI = request.put(url)
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json')
        .send(options);

      if (self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

      requestAPI
        .agent(keepaliveAgent)
        .end(function(error, response) {
          if (error) {
            var err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
            dfd.reject(err);
          }
          else { dfd.resolve(response.body); }
      });
    } else {
      var err = {};
      err.message = err.description = 'Mandatory param: productcode not found in request options.';
      err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
      dfd.reject(err);
    }
  }

  return dfd.promise;
}

/**
 * @param {
 *  *productcode: "string"
 * } options
 */
function getParticularOrgProductEntitlement(options) {
  var self = this;
  //Initializing promise
  var deferred = q.defer();

  if (options && options.productcode) {
    // Passed all validations, Contruct the API URL
    var url = self.config.DEFAULT_HOSTS.AUTHEXTN +
      self.config.AUTHEXTN_API_URLS.orgProductEntitlement;
    url = helpers.api.constructAPIUrl(url, { orgid: self.orgId });

    // Setup request with URL and Query Params
    var params = { productcode: options.productcode };
    var requestAPI = request.get(url).query(params);

    // Setup 'traceid' in request header
    if (self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

    requestAPI.agent(keepaliveAgent).end(function (error, response) {
      if (error) {
        error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
        deferred.reject(error);
      } else {
        deferred.resolve(response.body);
      }
    });
  } else {
    var error = {};
    error.message = error.description = 'Mandatory field \'productcode\' not found '+
      'in request options.';
    error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
    deferred.reject(error);
  }

  return deferred.promise;
}

/**
 * @param {
 *  status: "string"             // ['active', 'revoked']
 *  expired: <boolean>,
 *  cursor: <epoch>
 * } options
 */
function getAllOrgProductEntitlements(options) {
  var self = this;
  //Initializing promise
  var deferred = q.defer();

  // Contruct the API URL
  var url = self.config.DEFAULT_HOSTS.AUTHEXTN +
    self.config.AUTHEXTN_API_URLS.orgProductEntitlement;
  url = helpers.api.constructAPIUrl(url, { orgid: self.orgId });

  // Setup request with URL and Query Params
  var params = { productcode: options.productcode };

  if (options.status) { params.status = options.status; }
  if (options.hasOwnProperty('expired')) { params.expired = options.expired; }
  if (options.cursor) { params.cursor = options.cursor; }

  var requestAPI = request.get(url).query(params);

  // Setup 'traceid' in request header
  if (self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

  requestAPI.agent(keepaliveAgent).end(function (error, response) {
    if (error) {
      error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
      deferred.reject(error);
    } else {
      deferred.resolve(response.body);
    }
  });

  return deferred.promise;
}
